<template>
<div>
  <v-row justify="center" class="ma-0">
    <v-dialog v-model="bDialog"  max-width="800px" persistent>
      <v-card height="80%">
        <v-tabs>
          <v-tab center-active class="ml-4 text-subtitle-1 font-weight-bold"> 협력업체 찾기 </v-tab>
        </v-tabs>
        <v-divider></v-divider>

        <div class="pa-8 pt-2 pb-2" style="height:55px;">
          <v-row>
            <v-col cols="6" sm="4" md="4" class="pa-4">
              <v-text-field 
                dense
                ref="SearchKeyWord"
                v-model="cNowSearchKeyWord"  
                class="ml-n3 mb-n9" 
                label="업체명 or 사업자번호 입력"
                style="max-width:220px;"
                Regular
                v-on:keyup.enter="Search()"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="2" md="2">
              <v-btn color="black darken-1" text class="ml-n7 font-weight-bold" @click="Search()">
                <v-icon class="mr-0" >search</v-icon>검색
              </v-btn>
            </v-col>
          </v-row>
        </div>

        <v-divider></v-divider>
        <div style="height:calc(80vh - 200px);">
          <v-data-table
            :items-per-page="-1" 
            fixed-header
            hide-default-footer
            :headers="headers" 
            :items="Records"
            @click:row="handleClick"
            @dblclick:row="handleDoubleClick"
            v-model="selected"
            :single-select="true"
            show-select
            item-key="cBizCode"
            height="calc(80vh - 200px)"
            class="no-select"
          >
            <template v-slot:item.data-table-select="{ isSelected }">
              <v-icon class="ml-1" v-if="isSelected">done</v-icon>
            </template>
            <template v-slot:no-data>
              {{sMsg}}
            </template>
          </v-data-table>
        </div>

        <div class="ml-7 text-caption mt-8 word_keeper">* 더블클릭이나 선택후 확인버튼을 클릭하세요. [사업자번호 주의]</div> 
        <v-card-actions style="height:80px;">         
          <v-spacer></v-spacer>
          <v-btn @click="Close()" width="90px" class="mr-2" text><v-icon class="mr-1">mdi-close</v-icon>닫기</v-btn>
          <v-btn @click="SelectItem()" width="90px" class="ml-2" dark><v-icon class="mr-1">check</v-icon>확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <v-dialog v-model="dialog" persistent max-width="600">
    <v-card class="word_keeper">
      <v-card-title class="headline font-weight-bold">
        검색된 업체가 없습니다. 등록을 먼저 진행하여 주세요.
      </v-card-title>
      <v-divider class="ml-2 mr-2"></v-divider>
      <v-card-text class="mt-5">
        {{2-cCircularTime}}초뒤 협력업체 등록 화면으로 이동합니다.
      </v-card-text>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
// import BasicInfo from "@/BasicInfo.js";
import axios from "axios"
import EventBus from '@/eventBus.js';
import { mapState } from "vuex";

export default {
  components: {
  },

  data: () => ({
    dialog : false,
    bDialog : false,
    bMoveMode : false,
    cNowSearchKeyWord : "",
    cPageNm : "",
    sMsg : "",
    cCircularTime : 0,
    interval : {},
    selected: [],
    Records: [],
    headers: [
      { class: "font-weight-bold subtitle-2", text: "사업자등록번호", value: "cBizCode", align: "center", width: "70px"},
      { class: "font-weight-bold subtitle-2", text: "업체명(한글)", value: "cCorpNmKor", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "업체명(영문)", value: "cCorpNmEng", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "주소", value: "cAddr1", align: "center" },
      { class: "font-weight-bold subtitle-2", text: "전화번호", value: "cTel", align: "center" },
    ],
  }),
      
  computed: {
    ...mapState(["CustomInfo"]),
  },
  
  created() {
    this.Initialize();
  },

  methods: {
    CountTime() {
      this.interval = setInterval(() => {
        this.cCircularTime += 1
      }, 1000)
    },

    Open(PageNm,NowSearchKeyWord) {
      this.bDialog = true;
      this.Initialize();

      this.cPageNm = PageNm
      this.bMoveMode = ("MoveCorp" == PageNm)

      this.cNowSearchKeyWord = NowSearchKeyWord;
      this.Search();
    },

    Initialize() {
      this.cNowSearchKeyWord = "";
      this.Records= [];
      this.selected= [];
    },

    // 협력업체 찾기
    Search() {
      var posData = {
        SiteId : this.CustomInfo.SiteId,
        cCustomId : this.CustomInfo.CustomId,
        cCorpId : this.CustomInfo.CorpId,
        cNowSearchKeyWord : this.cNowSearchKeyWord,
        bMoveMode : this.bMoveMode,
      };
      //this.cNowSearchKeyWord 없으면 회사리스트 안나와야한다고 함
      if (!this.cNowSearchKeyWord || this.cNowSearchKeyWord.trim() === "") {
        this.Records = [];
        return;
      }

      axios
        .post(process.env.VUE_APP_UIL_API + "SearchCorp", posData, {
          headers: {
          }
        })
        .then(res => {
          if (res.data.ResultCd === "00") {  
            this.Records = res.data.Result;
            if (this.Records.length == 0) {
              setTimeout(() => {
                this.Records = [{}];
                this.Records[0].cCorpNmEng = "검색결과가 없습니다."
              }, 300);

              if (this.cPageNm == "Resist") {
                this.dialog = true;
                this.cCircularTime = 0;
                this.CountTime();
                setTimeout(() => {
                  clearInterval(this.interval)
                  this.dialog = false;
                  this.bDialog = false;
                  this.$emit("GetCorpInfo", {});
                }, 2000);
              }
            }
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    // onMsgBox 값 (취소시:false, 저장시:true)
    onMsgBoxFunc: function(result) {
      if (result === true) {
        this.bDialog = false; 
        EventBus.$emit("onResistCorpRun");     
      }
    },

    // 클릭시 항목선택
    handleClick(value) {      
      this.selected = [value];
    },

    // 항목 선택
    SelectItem() {
      this.$emit("GetCorpInfo", this.selected[0]);
      this.bDialog = false;  
    },

    // 테이블항목 더블클릭시 사업자번호 선택
    handleDoubleClick(value, items) { 
      this.$emit("GetCorpInfo", items.item);
      this.bDialog = false;  
    },

    // 다이올로그 취소시 닫음 
    Close() {      
      this.bDialog = false;
    }
  }
};
</script>

<style scoped>

</style>
